/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LicensingPhoneNumberType = "HOME" | "MOBILE" | "WORK" | "%future added value";
export type LicensingAccountInput = {
    dateOfBirth?: string | null | undefined;
    driverLicence?: string | null | undefined;
    firstName?: string | null | undefined;
    isSelfIdentifiedAsSeniorCitizen?: boolean | null | undefined;
    lastName?: string | null | undefined;
    middleName?: string | null | undefined;
    personNameSuffixId?: number | null | undefined;
    phoneNumbers: Array<LicensingPhoneNumberInput>;
};
export type LicensingPhoneNumberInput = {
    number?: string | null | undefined;
    type: LicensingPhoneNumberType;
};
export type updateAccountMutationVariables = {
    account: LicensingAccountInput;
};
export type updateAccountMutationResponse = {
    readonly updateLicensingAccount: {
        readonly account: {
            readonly id: string;
        } | null;
    } | null;
};
export type updateAccountMutation = {
    readonly response: updateAccountMutationResponse;
    readonly variables: updateAccountMutationVariables;
};



/*
mutation updateAccountMutation(
  $account: LicensingAccountInput!
) {
  updateLicensingAccount(account: $account) {
    account {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "account"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "account",
                    "variableName": "account"
                }
            ],
            "concreteType": "UpdateLicensingAccountAddressResponse",
            "kind": "LinkedField",
            "name": "updateLicensingAccount",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "updateAccountMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "updateAccountMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "1f8388774000b9f063abe5c671b8ab6b",
            "id": null,
            "metadata": {},
            "name": "updateAccountMutation",
            "operationKind": "mutation",
            "text": "mutation updateAccountMutation(\n  $account: LicensingAccountInput!\n) {\n  updateLicensingAccount(account: $account) {\n    account {\n      id\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'cacfa5aa28dc8c517994e777b005d752';
export default node;
